module.exports = __webpack_public_path__ + "static/media/custom-error.752a9df3.svg";